import { useState, useEffect, useCallback } from 'react';
import { getLessonUserList } from '../../api/lesson';

const useLessonUserLists = (storeId, searchDate) => {
  const [lessonList, setLessonList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!storeId || !searchDate) return; // 조건이 안 맞으면 아무것도 하지 않음
    setLoading(true); // fetch 시작 시점에 true
    try {
      const data = await getLessonUserList(storeId, searchDate);
      setLessonList(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }, [storeId, searchDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { lessonList, loading, error, refresh: fetchData };
};

export default useLessonUserLists;